///<reference path="../../employee/sections/employee.services.section.ts"/>
module Meevo.Plugins.Student {
    "use strict";

    /**
    * Services Section of Employee 
    */
    export class ServicesSection extends Meevo.Plugins.Employee.ServicesSection {
        public get auditNounForSave() {
            return Model.NounEnum.StudentServicesOverride;
        }
    }
}